// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3wHOK","ranges":"BmiRanges_ranges__303vo"};